import { refs, domReady } from '../modules/utils.js';
import { onScroll, animate } from 'animejs';
import { matches } from '../modules/media-queries.js';

class AltBoxes extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    if (!matches('sm')) {
      this.#init();
    }
  }

  #init() {
    if (!this.refs.column2) return;
    const itemsCount = this.refs.column2.children.length;
    const itemPercent = 100 / itemsCount;
    const percentStarting = -100 + itemPercent;
    const percentEnding = 100 - itemPercent;

    const animateParams = {
      y: {
        from: `${percentStarting}%`,
        to: `${percentEnding}%`
      },
      ease: 'linear',
      autoplay: onScroll({
        target: this.refs.column1,
        enter: 'top+=15% top',
        leave: 'bottom-=5% bottom',
        sync: true,
        debug: false
      })
    };

    animate(this.refs.column2, animateParams);
  }
}

customElements.define('alt-boxes', AltBoxes);
